import { selectCurrentHotelId } from 'accessors'
import { PMSsWithSyncLoginSupport } from 'constants'
import PMSLogo from 'features/PMSLogin/helpers/PMSLogo'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

import styles from './PmsMessage.module.scss'

const PmsMessage = ({ type, pmsLoginLink }) => {
  const currentSubsidiaryId = useSelector(selectCurrentHotelId)

  const pmsSyncStatuses = useSelector(s => s.pmsSyncStatus.list)
  const subsidiaryPMS = useSelector(s => s.login.subsidiaryPMS)

  const statusOfCurrentSubsidiary = pmsSyncStatuses?.find(
    s => s.subsidiaryId === currentSubsidiaryId
  )

  const notIntegrated = statusOfCurrentSubsidiary?.pmsHealthyKind === 'NotIntegrated'

  if (
    (statusOfCurrentSubsidiary?.isAllReportsHealthy === true && !notIntegrated) ||
    !PMSsWithSyncLoginSupport.includes(subsidiaryPMS)
  ) {
    return null
  }

  return (
    <div className={styles.headerContainer}>
      <div className={styles.logo}>{type && <PMSLogo pms={type} />}</div>
      <div className={styles.text}>
        Enable PMS sync to automate uploads and get better conversions.
      </div>
      <NavLink to={pmsLoginLink}>
        <button className={styles.primaryButton}>Enable</button>
      </NavLink>
    </div>
  )
}

export default PmsMessage
